import * as React from "react"

import { classNames } from "../../../utils/class-names"
import * as styles from "./index.module.scss"

interface PagingProps {
  isActive: boolean
  onClick: () => void
  durationInSeconds?: number
}

const Dot: React.FC<PagingProps> = ({
  isActive,
  onClick,
  durationInSeconds,
}) => {
  return (
    <button
      className={classNames(
        styles.dot,
        isActive && styles.active,
        !!durationInSeconds && styles.timer,
        "custom-slick-dots",
      )}
      style={{ "--time": `${durationInSeconds}s` } as React.CSSProperties}
      onClick={onClick}
      type="button"
      data-timer={durationInSeconds}
    />
  )
}
export default Dot
